import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { Input, message } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
// components
import BaseLayout from 'components/BaseLayout'
import TableComponent from 'components/Table'
import Modal from './Modal'
import SelectFilter from 'components/SelectFilter'
// helpers
import get from 'lodash/get'
import { columns } from './columns'

const types = [
  "Falla al canjear servicio",
  "La sección puntos ideas no carga",
  "Falla en carga de contenido",
  "No puedo redimir mis puntos",
  "No se abonaron mis puntos",
  "Falla al actualizar mi perfil"
]

const Layout: React.FC = () => {
  const {
    states: { filterSelected, page, searchInput, selectedUser, typeSelected },
    actions: { setFilterSelected, setPage, setSearchInput, setTypeSelected },
    queryHandler: { isFetching, data: dataQuery }
  } = useContext(Context)
  const [filter, setFilter] = useState('')

  const data = get(dataQuery, 'data', [])
  const paginationInfo = get(dataQuery, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 8,
    totalPages: 1,
    totalRecords: 1
  })

  useEffect(() => {
    const time = setTimeout(() => {
      if (filter != searchInput) setSearchInput(filter)
    }, 600)
    return () => clearTimeout(time)
  }, [filter])

  return (
    <>
      <BaseLayout title="Lista de tickets" bordered={false}>
        <Input
          size="large"
          placeholder="Busca por nombre, email o número celular"
          prefix={<SearchOutlined />}
          value={filter}
          onChange={e => setFilter(() => e.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
          <SelectFilter
            options={[
              { value: 'Cerrado', label: 'Cerrado' },
              { value: 'Activo', label: 'Activo' }
            ]}
            value={filterSelected}
            setValue={setFilterSelected}
            placeholder='Seleccione un estado'
          />
          <SelectFilter
            options={types.map(type => ({ label: type, value: type }))}
            value={typeSelected}
            hideIcon
            setValue={setTypeSelected}
            placeholder='Seleccione un tipo de incidencia'
            noBadge
          />
        </div>
        <TableComponent
          emptyData={data.length === 0 && !isFetching}
          columns={columns}
          data={data}
          rows={9}
          loading={isFetching}
          page={page}
          total={paginationInfo.totalRecords}
          setPage={setPage}
        />
      </BaseLayout>
      {/* <Modal key={selectedUser} /> */}
    </>
  )
}

export default Layout
